<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

  <div class="row mcr">
    <div class="col-md-6 about">
      <div class="elip"></div>
      <div style="position: absolute;z-index: 2;left: 0; height: 100%; width: 100%;">
        <div style="display: flex; flex-direction: column; align-items: center;justify-content: center; height: 100%;">
          <div class="logo">
            <img src=".\assets\images\sulogo.png" style="width:250px" alt="logo">
          </div>
      
          <h6 class="psub-title" style="text-align: center; ">Hello! Log in with your email.</h6>
      
          <div class="imge">
            <img src=".\assets\images\Recruitment Agencies ( verification).svg">
          </div>
      
              <h5 style="text-align: center;">Don't have an account? <a style="color:DodgerBlue;" class="text-link"
                  routerLink="../register">Register</a></h5>
              <!-- <h5 style="text-align: center;">Are you an agent? <a class="text-link" style="color:DodgerBlue;"
                  routerLink="../registerAgent">Register as Agent</a></h5> -->
        </div>
      </div>
  
    </div>
  
    <div class="col-md-6 form">
  
      <h1 id="title" class="title">Login</h1>
      <h6 class="sub-title">Hello! Log in with your email.</h6>
  
      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Oh snap!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>
  
      <nb-alert *ngIf="verify_message == true" [outline]=outln role="alert">
        <p class="alert-title"><b>{{messageHeading}}!</b></p>
        <ul class="alert-message-list">
          <li class="alert-message">{{message}}</li>
        </ul>
      </nb-alert>
  
      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Hooray!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
      </nb-alert>
  
      <div [formGroup]="loginForm" aria-labelledby="title">
        <div class="form-control-group">
          <label for="input-email">Email address:</label>
          <input nbInput fullWidth id="input-email" formControlName="email"
            [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : ''"
            [attr.aria-invalid]="email.invalid && email.touched ? true : null" placeholder="Email address">
          <ngx-validation-message label="Email address" [showPattern]="email?.hasError('pattern') && email.touched"
            [showRequired]="email?.errors?.required && email.touched"></ngx-validation-message>
        </div>
  
  
        <div class="form-control-group">
          <span class="label-with-link">
            <label class="label" for="input-password">Password:</label>
  
          </span>
          <div class="input-group" style="position: relative;">
            <input nbInput fullWidth id="input-password" formControlName="password" type="{{ passwordType }}"
              [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : ''" placeholder="Password">
            <i style="position: absolute; right: 3%; top: 30%;" (click)="togglePasswordVisibility()"
              class="{{ passwordIcon }}"></i>
          </div>
          <ngx-validation-message label="Password" [showMinLength]="password?.hasError('minlength') && password.touched"
            [showMaxLength]="password?.hasError('maxlength') && password.touched"
            [showRequired]="password?.errors?.required && password.touched" [minLength]="minLength"
            [maxLength]="maxLength"></ngx-validation-message>
        </div>
  
        <div class="form-control-group accept-group">
          <nb-checkbox formControlName="rememberMe" name="rememberMe" *ngIf="rememberMe">Remember me</nb-checkbox>
          <a class="forgot-password caption-2" routerLink="../request-password">Forgot Password?</a>
        </div>
  
        <button nbButton fullWidth status="primary" size="large" (click)="login()"
          [disabled]="submitted || !loginForm.valid" [class.btn-pulse]="submitted">
          Log In
        </button>
      </div>
  
      <h6 class="login1">
        Don't have an account? <a class="text-link" routerLink="../register">Register as Student</a>
      </h6>
      <!-- <h6 class="login1">
        Are you an agent? <a class="text-link" routerLink="../registerAgent">Register as Agent</a>
      </h6> -->
  
    </div>
  </div>